<template>
    <v-col cols="12" md="3">
    <v-card class="ma-2">
        <v-card-title class="title font-weight-black">
            <v-icon class="pr-3">home</v-icon> Register New Hotel
        </v-card-title>

        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <fieldset>
                            <legend>Basic Details</legend>

                            <div class="mb-4">
                                <input name="bookable_via_iescape"
                                    type="checkbox"
                                    v-model="bookableViaIescape"
                                > <label for="bookableViaIescape">Bookable via i-escape</label>
                            </div>

                            <v-text-field 
                                v-model="hotelName"
                                label="Hotel Name"
                                outlined
                                dense></v-text-field>

                            <v-autocomplete
                                v-model="regionKey"
                                label="Region"
                                :items="regions"
                                outlined
                                dense
                            ></v-autocomplete>

                            <v-autocomplete
                                v-model="billing"
                                label="Billing Type"
                                :items="billingTypes"
                                outlined
                                dense
                                :disabled="!bookableViaIescape && !bookableViaPartner && !bookableViaDirect"
                            />

                            <v-text-field 
                                v-model="commission"
                                label="Commission (%)"
                                :disabled="!bookableViaIescape && !bookableViaPartner && !bookableViaDirect"
                                outlined
                                dense></v-text-field>

                            <v-btn v-on:click="save()" 
                                   class="lime" 
                                   :disabled="saving">Create</v-btn>
                       </fieldset>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
    </v-col>
</template>

<script>
    /**
     * Display buttons linking through to hotels' pages
     */
    export default {
        props:[],

        data: function() {
            return {
                bookableViaIescape: true,
                bookableViaDirect: false,
                bookableViaPartner: false,
                regions: [],
                displayStatuses: [{value: 0, text: "Offline"}, {value: 1, text: "Online"}, {value: 2, text: "Preview"}],
                hotelName: "",
                regionKey: null,
                commission: 15.0,
                billing: 1,
                billingTypes: [{value: 1, text: "Upfront Deposit"}, {value: 2, text: "In Arrears"}],
                saving: false
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){
            this.getRegions();
        },

        methods: {
            /**
             * @method save 
             * 
             * Submit the data to register the minimal new hotel record
             */
            save: function(){
                if (this.saving){
                    return;
                }

                this.saving = true;
                axios.post('/api/hotels/register', {
                    hotelName: this.hotelName,
                    regionKey: this.regionKey,
                    commission: this.commission,
                    billing: this.billing,
                    bookableViaIescape: this.bookableViaIescape,
                    bookableViaPartner: this.bookableViaPartner,
                    bookableViaDirect: this.bookableViaDirect,
                })
                .then((response)=>{
                    // If it was successful then redirect to the hotel's dashboard page for onward user journey 
                    if (response.data.success){
                        console.log(response.data);
                        var hotel = response.data.hotel;
                        window.location.href="/hotel/" + hotel.hotel_key + '/dashboard';
                    }
                    // If it failed then simply tell them so
                    else {
                        this.saving = false;
                        alert("A problem occurred and the hotel could not be created");
                    }
                });
            },

            /**
             * @method getRegions
             * 
             * Populates the view-model list of selectable region options to which the hotel can be assigned
             */
            getRegions:function(){
                axios.get('/api/selectable-regions')
                .then(function(response){
                    var regions = [];
                    response.data.regions.forEach(function(record){
                        regions.push({ text: record.region_name, value: record.region_key });
                    });
                    this.regions = regions;
                }.bind(this));
            },
        },

        computed: {}
    }
</script>
